var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 178.233,
    viewBox: "0 0 144 178.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{fill:#4b4b4b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hospitality_",
    transform: "translate(.332 -.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_344",
    d: "M0 0H144V178H0z",
    className: "cls-1",
    transform: "translate(-.332 .026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_324",
    d: "M0 0H9V13H0z",
    className: "cls-1",
    transform: "translate(33.667 91.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_333",
    d: "M0 0H9V13H0z",
    className: "cls-1",
    transform: "translate(33.667 115.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_334",
    d: "M0 0H9V14H0z",
    className: "cls-1",
    transform: "translate(33.667 139.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_336",
    d: "M0 0H10V14H0z",
    className: "cls-1",
    transform: "translate(84.667 139.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_325",
    d: "M0 0H9V13H0z",
    className: "cls-1",
    transform: "translate(50.667 91.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_332",
    d: "M0 0H9V13H0z",
    className: "cls-1",
    transform: "translate(50.667 115.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_335",
    d: "M0 0H9V14H0z",
    className: "cls-1",
    transform: "translate(50.667 139.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_337",
    d: "M0 0H10V14H0z",
    className: "cls-1",
    transform: "translate(101.667 139.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_326",
    d: "M0 0H10V14H0z",
    className: "cls-1",
    transform: "translate(67.667 92.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_331",
    d: "M0 0H10V13H0z",
    className: "cls-1",
    transform: "translate(67.667 117.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_327",
    d: "M0 0H10V13H0z",
    className: "cls-1",
    transform: "translate(84.667 91.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_330",
    d: "M0 0H10V13H0z",
    className: "cls-1",
    transform: "translate(84.667 115.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_328",
    d: "M0 0H10V13H0z",
    className: "cls-1",
    transform: "translate(101.667 91.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_329",
    d: "M0 0H10V13H0z",
    className: "cls-1",
    transform: "translate(101.667 115.026)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    transform: "translate(4.487 62.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    d: "M441.137 390.571c0 1.881-.006 3.762.006 5.642.009 1.294.526 1.8 1.843 1.806q4.324.016 8.652 0c1.358 0 1.913-.544 1.913-1.863q0-7.891-.025-15.78c0-1.364-.518-1.875-1.9-1.884-2.834-.02-5.709-.02-8.544 0-1.469.011-1.919.465-1.926 1.943q-.008 2.593 0 5.186v2.812h-.022zm2.4-9.671h7.613v9.745h-7.613zm-.013 12.149h2.167c1.576 0 3.127 0 4.678.007a.886.886 0 0 1 .683.246 1.106 1.106 0 0 1 .178.872 2.23 2.23 0 0 0-.012.262l.009.134a1.138 1.138 0 0 1-.188.893.9.9 0 0 1-.695.245h-6.821z",
    className: "cls-2",
    transform: "translate(-396.804 -350.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    d: "M481.292 398.013c2.984.028 5.965.035 8.886.02 1.337-.007 1.86-.543 1.868-1.909q.008-2.629 0-5.256v-2.332h-.023v-2.679c0-1.871.005-3.742-.005-5.613-.007-1.208-.508-1.73-1.672-1.743-2.981-.039-6-.039-8.976 0a1.683 1.683 0 0 0-.4 0 1.522 1.522 0 0 0-1.311 1.7c-.021 5.335-.026 10.751-.013 16.134a1.879 1.879 0 0 0 0 .267 1.524 1.524 0 0 0 1.646 1.411zm.75-17.125h7.61v9.759h-7.615zm.079 12.438l.039-.205h7.5v2.6h-5.587a1.189 1.189 0 0 1-.138-.01.6.6 0 0 0-.08-.007c-.968-.045-1.48-.084-1.747-.424s-.192-.88.013-1.953z",
    className: "cls-2",
    transform: "translate(-400.753 -350.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    d: "M471.894 380.549c-.005-1.568-.486-2.049-2.062-2.058-1.4-.007-2.807-.011-4.217-.011s-2.816 0-4.215.011-1.856.482-1.865 1.882c-.012 1.878-.009 3.756-.007 5.633V390.619c0 1.807-.005 3.613 0 5.421.005 1.512.471 1.973 1.995 1.973q1.863 0 3.725-.005c1.533 0 3.066-.009 4.6 0a1.656 1.656 0 0 0 2.066-2.01q.003-7.726-.02-15.449zm-9.991.311h7.583v9.815H461.9zm7.612 14.771h-7.59v-2.455h7.59z",
    className: "cls-2",
    transform: "translate(-398.691 -350.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    d: "M434.264 380.489c-.005-1.424-.544-1.983-1.922-2s-2.773-.019-4.164-.019-2.783.005-4.164.019c-1.619.017-2.113.516-2.118 2.141q-.02 7.672-.021 15.345c0 1.526.529 2.043 2.094 2.051 1.894.007 3.784 0 5.676 0l2.54-.008c1.492 0 2.075-.585 2.08-2.075q.005-2.594 0-5.19v-5.148q.004-2.558-.001-5.116zm-9.8.6a1.239 1.239 0 0 1 .954-.279c1.444.032 2.866.025 4.374.021q.906 0 1.832-.005h.254v9.841h-7.681v-4.528c0-1.326.01-2.7-.02-4.044a1.342 1.342 0 0 1 .284-1.002zm7.464 14.606h-.254c-.649 0-1.293 0-1.937.006-.625 0-1.258.006-1.895.006-.949 0-1.905-.007-2.848-.031a.855.855 0 0 1-.663-.254 1.074 1.074 0 0 1-.138-.874 1.579 1.579 0 0 0 .018-.367 1.016 1.016 0 0 1 .161-.865.992.992 0 0 1 .76-.284c1.531.011 3.062.007 4.635.007h2.161z",
    className: "cls-2",
    transform: "translate(-394.829 -350.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    d: "M500.666 398.027c2.921.024 5.833.025 8.685.006a2 2 0 0 0 .528 0 1.708 1.708 0 0 0 1.439-1.938v-5.228l-.024-2.6v-2.632c0-1.755.006-3.509 0-5.263-.007-1.315-.532-1.858-1.814-1.876-2.91-.034-5.861-.034-8.768 0a1.8 1.8 0 0 0-.4 0 1.6 1.6 0 0 0-1.382 1.781c-.02 5.264-.026 10.614-.014 15.935a1.727 1.727 0 0 0 0 .395 1.583 1.583 0 0 0 1.75 1.42zm.637-17.135h7.6v9.78h-7.6zm-.077 13.269a1.135 1.135 0 0 1 .219-.881.991.991 0 0 1 .768-.244c1.364.018 2.728.016 4.094.011h1.584c.15 0 .3.013.461.027l.371.029.068.115a1.677 1.677 0 0 1 .156.347c.118 1.068.168 1.531-.109 1.841s-.749.306-1.693.306h-.016l-1.262-.006c-1.168-.009-2.374-.017-3.557.02h-.076a1.021 1.021 0 0 1-.766-.257 1.37 1.37 0 0 1-.241-1.059c.004-.081.002-.166-.001-.249z",
    className: "cls-2",
    transform: "translate(-402.73 -350.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    d: "M453.577 412.7c0-1.9.006-3.794-.01-5.691-.01-1.255-.507-1.749-1.772-1.757-1.618-.01-3.242-.014-4.854-.014q-2.019 0-4.011.01c-1.277.007-1.752.48-1.752 1.748-.016 5.306-.016 10.685 0 15.989 0 1.248.485 1.715 1.776 1.721q4.327.014 8.652.007c1.426 0 1.932-.51 1.938-1.937q.008-2.591 0-5.184v-2.88h.029zm-10.038-5.088h7.687v1.862c0 2.472 0 4.807-.025 7.192l-.01.068a1.011 1.011 0 0 1-.7.687c-1.4.029-2.743.034-4.122.034h-2.833zm7.692 13.746c-.022.131-.03.263-.041.432l-.044.565h-7.6v-2.559h3.354a7.824 7.824 0 0 1 .879.012 18.056 18.056 0 0 0 1.935-.03 1.5 1.5 0 0 1 1.286.322 1.421 1.421 0 0 1 .231 1.256z",
    className: "cls-2",
    transform: "translate(-396.808 -353.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    d: "M492.022 407.092c-.005-1.415-.458-1.871-1.863-1.878-2.553-.009-5.339 0-8.77.028a1.95 1.95 0 0 0-.267-.019 1.568 1.568 0 0 0-.207.013 1.478 1.478 0 0 0-1.252 1.67c-.02 5.389-.021 10.777 0 16.051 0 1.2.558 1.739 1.8 1.746q4.387.011 8.774 0c1.317 0 1.785-.482 1.79-1.825q.008-2.63 0-5.263V412.268q0-2.59-.005-5.176zm-10.052.486h7.658v9.884h-5.368c-1.066 0-1.614-.011-1.945-.338s-.346-.909-.346-2.043zm7.665 14.755h-7.568v-2.508h7.568z",
    className: "cls-2",
    transform: "translate(-400.754 -353.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    d: "M511.3 407.045c-.008-1.262-.561-1.8-1.85-1.811q-4.269-.023-8.539-.028c-1.385 0-1.976.584-1.976 1.949q-.016 7.836 0 15.671c0 1.325.558 1.868 1.912 1.874q4.274.017 8.548 0c1.4-.007 1.9-.525 1.9-1.98q.005-2.558 0-5.114v-5.224c.005-1.782.01-3.556.005-5.337zm-10.008.578h7.624v9.752h-7.626zm7.64 14.7h-7.6l-.052-.478c-.016-.15-.029-.284-.05-.417a1.5 1.5 0 0 1 .219-1.3 1.56 1.56 0 0 1 1.317-.373c1.364.066 2.707.052 4.125.038.591-.005 1.185-.012 1.786-.012h.255z",
    className: "cls-2",
    transform: "translate(-402.732 -353.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    d: "M432.582 405.245c-2.717-.037-5.688-.044-9.087-.021h-.057a1.508 1.508 0 0 0-1.51 1.438 9.19 9.19 0 0 0-.059 1.189q0 7.459.024 14.913c.005 1.389.556 1.933 1.962 1.939q4.223.015 8.44 0c1.451-.005 1.966-.539 1.966-2.041l.022-10.381c0-1.729.005-3.459 0-5.188-.011-1.278-.519-1.83-1.701-1.848zm-8.324 2.37h7.631v9.742h-7.631zM431.9 422.4H428.821c-1.278 0-2.572-.008-3.846-.047-.4-.011-.756-.815-.749-1.19.005-.311.278-1.3.722-1.316 1.763-.06 3.492-.054 5.316-.051h1.635z",
    className: "cls-2",
    transform: "translate(-394.828 -353.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    d: "M421.889 433.965q-.012 7.674 0 15.346c0 1.62.481 2.091 2.134 2.1q4.108.018 8.217 0c1.53-.007 2.022-.516 2.022-2.1V439.813q0-2.921-.005-5.851c0-1.539-.507-2.034-2.071-2.042q-2.054-.007-4.108-.007t-4.108.007c-1.575.009-2.081.505-2.081 2.045zm9.991 15.028h-7.615v-2.442h7.615zm-7.652-13.852a1.16 1.16 0 0 1 .8-.868l.063-.01c1.673-.038 3.314-.037 5.05-.031h1.739v9.936H428.522c-1.159 0-2.289-.005-3.434-.029l-.067-.011a1.151 1.151 0 0 1-.788-.814c-.047-2.746-.047-5.479-.005-8.173z",
    className: "cls-2",
    transform: "translate(-394.83 -356.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    d: "M460.435 422.85c.007 1.385.48 1.853 1.874 1.853q4.219.011 8.435 0c1.6 0 2.037-.442 2.044-2.034q.012-3.172.01-6.344V412.7c0-.654.005-1.307.01-1.961.008-1.244.017-2.487 0-3.731-.013-1.19-.564-1.794-1.641-1.794q-4.432 0-8.864.02c-1.426.006-1.864.438-1.873 1.848-.008 1.75 0 3.5 0 5.251v5.496l.005 5.021zm9.981-.5h-7.592v-2.49h7.592zm-7.624-14.757h7.688V413.082c.005 1.085.011 2.207-.024 3.312-.01.305-.326 1.019-.722 1.019-1.324.031-2.629.038-3.972.038h-2.973z",
    className: "cls-2",
    transform: "translate(-398.784 -353.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    d: "M511.3 433.859c-.007-1.4-.538-1.925-1.959-1.931q-2.083-.007-4.163-.007t-4.164.007c-1.574.006-2.079.5-2.079 2.048q-.012 7.726 0 15.452c0 1.414.54 1.969 1.922 1.977 2.835.018 5.71.018 8.544 0 1.4-.01 1.9-.529 1.9-1.983q.005-2.593 0-5.185v-5.188l-.001-5.19zm-10.069 5.841v-4.02c0-.237.014-.474.029-.73l.034-.654h7.621v9.873h-5.254c-2.316 0-2.429-.116-2.429-2.463zm7.694 9.308H501.3v-2.438h7.626z",
    className: "cls-2",
    transform: "translate(-402.732 -356.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    d: "M492.021 433.911c-.007-1.436-.527-1.972-1.919-1.978s-2.813-.011-4.222-.011-2.819 0-4.217.011c-1.438.006-2 .58-2 2.044-.015 5.129-.015 10.329 0 15.458 0 1.389.573 1.961 1.962 1.971 2.8.016 5.64.016 8.439 0 1.479-.01 1.956-.505 1.962-2.039q.007-2.559 0-5.115v-5.07q0-2.636-.005-5.271zm-10.038 2.389v-2.025h7.651v9.892h-2.988c-1.3 0-2.565 0-3.852-.031a1.037 1.037 0 0 1-.788-.863c-.026-2.3-.025-4.573-.023-6.973zm7.68 12.718h-7.621v-2.448h7.622z",
    className: "cls-2",
    transform: "translate(-400.754 -356.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    d: "M453.225 450.789a1.611 1.611 0 0 0 .319-1.2c.014-5.237.014-10.511 0-15.711-.007-1.356-.6-1.938-1.991-1.944s-2.813-.013-4.222-.013-2.82 0-4.218.013-1.932.54-1.942 1.966c-.012 1.853-.009 3.706-.007 5.56v4.093c0 1.972-.005 3.943.012 5.919.008 1.365.547 1.925 1.857 1.935 2.874.022 5.786.022 8.658 0a1.818 1.818 0 0 0 .463 0 1.609 1.609 0 0 0 1.071-.618zm-2.068-1.755h-7.6v-2.445h7.606zm-.208-5.125a1.223 1.223 0 0 1-.911.287h-.08c-1.442-.039-2.919-.031-4.346-.024q-.891.005-1.791.006h-.229l-.024-.227c-.014-.136-.03-.255-.044-.363a4.868 4.868 0 0 1-.051-.525v-8.749h7.642l.056.5a5.279 5.279 0 0 1 .058.692v2.49c0 1.588-.006 3.23.019 4.843a1.43 1.43 0 0 1-.299 1.069z",
    className: "cls-2",
    transform: "translate(-396.807 -356.419)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    transform: "translate(32.581 7.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    d: "M432.585 355.726l1.4 2.844 3.141.456-2.273 2.211.538 3.126-2.807-1.475-2.807 1.475.538-3.126-2.276-2.211 3.141-.456z",
    className: "cls-2",
    transform: "translate(-428.043 -355.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    d: "M449.248 355.726l1.4 2.844 3.141.456-2.273 2.211.538 3.126-2.807-1.475-2.807 1.475.538-3.126-2.271-2.214 3.141-.456z",
    className: "cls-2",
    transform: "translate(-429.753 -355.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    d: "M465.912 355.726l1.4 2.844 3.141.456-2.271 2.214.538 3.126-2.807-1.475-2.807 1.475.538-3.126-2.271-2.214 3.141-.456z",
    className: "cls-2",
    transform: "translate(-431.462 -355.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    d: "M482.575 355.726l1.4 2.844 3.141.456-2.271 2.214.538 3.126-2.807-1.475-2.807 1.475.539-3.126-2.271-2.214 3.141-.456z",
    className: "cls-2",
    transform: "translate(-433.171 -355.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    d: "M499.237 355.726l1.4 2.844 3.141.456-2.271 2.214.538 3.126-2.807-1.475-2.807 1.475.538-3.126-2.271-2.214 3.141-.456z",
    className: "cls-2",
    transform: "translate(-434.88 -355.726)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    d: "M525.8 454.676h-5.5c-4.287 0-8.721-.008-13.081.024a1.629 1.629 0 0 1-1.159-.319 1.6 1.6 0 0 1-.328-1.158c.022-20.236.023-40.757.005-60.992v-7.351-14.7a9.067 9.067 0 0 0-.256-2.1c-1.5-6.168-3.044-12.434-4.585-18.622-.348-1.413-.663-1.661-2.112-1.661h-81.3c-1.457 0-1.774.247-2.122 1.649q-2.173 8.778-4.336 17.557a12.422 12.422 0 0 0-.489 2.856q-.03 12.483-.011 24.995v10.968q0 23.7.005 47.4a1.6 1.6 0 0 1-.328 1.172 1.561 1.561 0 0 1-1.147.318c-4.047-.037-8.168-.03-12.148-.026h-5.174v1.892H525.8zm-110.293-96.148c.587-2.369 1.195-4.819 1.759-7.237a1.358 1.358 0 0 1 1.567-1.223c25.7.022 52.168.023 78.661.01.658 0 1.221.073 1.436.968q1.361 5.644 2.762 11.282l1.178 4.786a5.084 5.084 0 0 1 .067.687l.008.261h-89.786zm52.239 96.149h-17.641c-1.579 0-1.69-.109-1.69-1.662V451.3h19.331zM452.42 441.42l-.005-4.9v-5.265a5.487 5.487 0 0 1 5.3-5.659 4.611 4.611 0 0 1 .473 0 5.459 5.459 0 0 1 5.648 5.264c0 .129.005.255 0 .383v5.4c0 3.547-.005 7.214.026 10.82a1.524 1.524 0 0 1-.331 1.16 1.486 1.486 0 0 1-1.073.319h-.1c-2.834-.06-5.709-.06-8.546 0a1.4 1.4 0 0 1-1.1-.311 1.537 1.537 0 0 1-.31-1.148c.03-2.013.025-4.072.019-6.064zm50.916 13.18h-33.2v-3.566c0-.918-.129-1.431-.419-1.713a2.416 2.416 0 0 0-1.7-.4h-1.862v-1.639q0-2.4.005-4.8c.007-3.821.013-7.774-.02-11.659a7.619 7.619 0 0 0-6.919-7.477 7.933 7.933 0 0 0-8.8 5.466 9.217 9.217 0 0 0-.3 2.409c-.02 4.006-.017 8.011-.015 12.015v5.68h-1.029c-.459 0-.881-.007-1.3 0a1.5 1.5 0 0 0-1.116.311 1.47 1.47 0 0 0-.545.986 1.452 1.452 0 0 0 0 .324c-.02.882-.015 1.729-.01 2.6v1.454h-33.218V370.53h90.451z",
    className: "cls-2",
    transform: "translate(-391.738 -347.79)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    fill: "none",
    stroke: "#4b4b4b",
    strokeMiterlimit: 10,
    strokeWidth: "2.551px",
    d: "M392 467v7.179h133.718V467",
    transform: "translate(-391.765 -360.017)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitality);
export default __webpack_public_path__ + "static/media/hospitality.2611e30c13621f981cecdfe3267537e6.svg";
export { ForwardRef as ReactComponent };